export const DEFAULT_SURFACE = {
  baseColor: "#e7e3d8",
  baseTexture: null,

  normalMap: null,
  normalStrength: 1.0,

  heightMap: null,
  heightStrength: 0.05,

  aoMap: null,

  emissiveColor: "#000000",
  emissiveMap: null,

  textureScale: [1.0, 1.0],

  textureRotation: 0.0,
};

export function createSurface(overrides = {}) {
  return {
    ...DEFAULT_SURFACE,
    ...overrides,

    textureScale: [...(overrides.textureScale ?? DEFAULT_SURFACE.textureScale)],
  };
}
